import Component from '@glimmer/component';
import { service } from '@ember/service';
import { LinkTo } from '@ember/routing';
import t from 'ember-intl/helpers/t';
import type { IntlService } from 'ember-intl';
import { Header, VStack } from 'tio-ui/components/layout';
import type { RecommendationExtension as RecommendationModel } from 'tio-data/data/resources/recommendation.ext';
import LoanPlansSection from 'tio-common/components/strategy-finder-0726/loan-plans-section';
import { parseResultSections } from 'tio-common/utils/strategy-finder-0726';

interface ForgivenessEstimator0726ResultsTableSignature {
  Args: {
    recommendation: RecommendationModel;
  };
  Element: HTMLElement;
}

export default class ForgivenessEstimator0726ResultsTableComponent extends Component<ForgivenessEstimator0726ResultsTableSignature> {
  @service declare intl: IntlService;

  // The stored recommendation is already filtered to PSLF-only plans by the
  // backend (see tio-api SortPlansEstimatorFilter), so just parse it.
  get sections() {
    return parseResultSections(
      this.args.recommendation.calculationInput,
      this.args.recommendation.calculationOutput
    );
  }

  <template>
    <VStack data-test-fe-0726-results ...attributes>
      <Header>
        {{t "strategy_finder_0726.results.title"}}
      </Header>
      {{#if @recommendation.hasErrorsInCalcs}}
        <div class="m-2" data-test-fe-0726-results-error>
          {{t "strategy_finder_0726.results.error_in_calcs"}}
          <LinkTo
            @route="authenticated.pslf.dashboard.forgiveness-estimator.index"
            class="tio-copy"
          >
            {{t "strategy_finder_0726.results.error_link_text"}}
          </LinkTo>
        </div>
      {{else}}
        {{#each this.sections as |section|}}
          <LoanPlansSection @section={{section}} @analysisDate={{@recommendation.createdAt}} />
        {{/each}}
      {{/if}}
    </VStack>
  </template>
}
